
import { allowLog } from '../globals';
const Prefix = "[SVP]";

class DebugLog {
    constructor() {

    }
    error() {
    	if(allowLog){
            let props = [...arguments];
            props[0] = `${Prefix} ${props[0]}`;
        	console.error.apply(console, props);
    	}
    }
    log() {
        if (allowLog) {
            let props = [...arguments];
            props[0] = `${Prefix} ${props[0]}`;
            console.log.apply(console, props);
        }
    }
    warn() {
        if (allowLog) {
            let props = [...arguments];
            props[0] = `${Prefix} ${props[0]}`;
            console.warn.apply(console, props);
        }
    }
}

const debug = new DebugLog();
export { debug }